import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type DiscardTemplateModalProps = {
  isOpen: boolean;
  close: () => void;
  onDiscard: () => void;
  isLoading?: boolean;
};

export const DiscardTemplateModal = ({
  isOpen,
  close,
  onDiscard,
  isLoading = false,
}: DiscardTemplateModalProps) => (
  <Modal.Root open={isOpen} onOpenChange={close}>
    <Modal.Content size="small">
      <StatusModal type="danger" title="Delete current checklist?">
        All progress on this checklist will be permanently deleted. This action
        cannot be undone.
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button type="button" disabled={isLoading}>
            Go back
          </Button>
        </Modal.RawClose>
        <Button
          type="button"
          customType="danger"
          isLoading={isLoading}
          disabled={isLoading}
          onClick={onDiscard}
        >
          Delete template
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
